import { BookMarked, ScrollText } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Persistent pill-shaped mode switcher (segmented control).
 * Shows both "Book Mode" / "Study Mode" options side-by-side with a
 * clear active state. Labels switch with i18n.
 */
export default function ModeToggle({ mode, onModeChange }) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="mode-toggle-segmented"
      className="inline-flex items-center gap-0.5 rounded-full border border-gold/30 bg-card/80 p-0.5"
      role="group"
      aria-label={t("mode_toggle.group_aria")}
    >
      <button
        type="button"
        onClick={() => onModeChange("book")}
        data-testid="mode-book"
        data-active={mode === "book" ? "true" : "false"}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-heading transition-all ${
          mode === "book"
            ? "bg-gold text-background shadow-sm"
            : "text-foreground hover:text-gold"
        }`}
        aria-pressed={mode === "book"}
      >
        <BookMarked className="h-3.5 w-3.5" strokeWidth={1.5} />
        <span className="hidden sm:inline">{t("mode_toggle.book")}</span>
      </button>
      <button
        type="button"
        onClick={() => onModeChange("study")}
        data-testid="mode-study"
        data-active={mode === "study" ? "true" : "false"}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-heading transition-all ${
          mode === "study"
            ? "bg-gold text-background shadow-sm"
            : "text-foreground hover:text-gold"
        }`}
        aria-pressed={mode === "study"}
      >
        <ScrollText className="h-3.5 w-3.5" strokeWidth={1.5} />
        <span className="hidden sm:inline">{t("mode_toggle.study")}</span>
      </button>
    </div>
  );
}
